export default __webpack_public_path__ + "static/media/receipt.ed2e1198.svg";